<template>
  <div class="Pos_main">
    <!-- Sales-Brand -->

    <div class="pos_all">
      <div
        class="all_nav"
        style="display: flex; justify-content: space-between"
      >
        <div>
          <p>Sell in Summary (KRMB) - {{ title }}</p>
        </div>

        <div>
          <span class="ellipsis">更新时间：{{ updataTimeIn }}</span> <br />
          <!-- typeValue.timeGoneWeekly Pattern -->
          <span>
            {{ typeValue.weekPattern ? "Weekly Pattern" : "Time Gone" }}:
            {{
              typeValue.weekPattern
                ? typeValue.weekPattern * 100
                : (typeValue.timeGone * 100) | NumFormat
            }}%</span
          >
        </div>
      </div>
      <SellIn></SellIn>
    </div>

    <div class="pos_all">
      <div
        class="all_nav"
        style="display: flex; justify-content: space-between"
      >
        <div>
          <p>Sell out Summary (KRMB) - {{ title }}</p>
        </div>

        <div>
          <span class="ellipsis">更新时间：{{ updataTimeOut }}</span> <br />

          <span>
            {{ typeValue.weekPatternSellout ? "Weekly Pattern" : "Time Gone" }}:
            {{
              typeValue.weekPatternSellout
                ? typeValue.weekPatternSellout * 100
                : (typeValue.timeGoneSellout * 100) | NumFormat
            }}%
          </span>
        </div>
      </div>
      <SellOut></SellOut>
    </div>

    <div class="pos_Tmall">
      <div class="Tmall_nav" style="height: 36px">
        <p>By BU (KRMB) - {{ title }}</p>
      </div>
      <BuTable></BuTable>
    </div>
  </div>
</template>
<script>
import SellIn from "@/components/ButSecoend/Summary/Sellin";
import SellOut from "@/components/ButSecoend/Summary/Sellout";

import BuTable from "@/components/ButSecoend/Bu/BuTable";

export default {
  data() {
    return {
      achVing: sessionStorage.getItem("achVing"),
      updataTimeIn: "",
      updataTimeOut: "",
      typeValue: {},

      title: "",
    };
  },
  methods: {
    getTime() {
      this.$addr
        // .get("http://10.216.226.81:8080/mobile_api/sellin/getUpdateDate")
        // .get("sellin/getUpdateDate")
        .get("sellinAndsellout/getUpdateDateSellinAndSellout")
        .then((res) => {
          this.updataTimeIn = res.data.data.GTS_UPDATE_DATE;
          this.updataTimeOut = res.data.data.VERSION_UPDATE_DATE_SELLOUT;

          this.title = res.data.data.YYYYMM_EN;
        })
        .catch((error) => {
          this.$toast("接受数据失败");
        });
    },

    getTypeData() {
      this.$addr
        // .post("/getSalesData", qs.stringify({ brandCd: this.brandName }))
        // .get("http://10.216.226.81:8080/mobile_api/sellin/getBuByList")
        // .get("sellin/getTargetType")
        .get("sellinAndsellout/getSumDataSellinAndSellout")
        .then((res) => {
          if (res.data.error == 0) {
            this.typeValue = res.data.data[0];
          }
        })
        .catch((error) => {
          this.$toast("接受数据失败");
        });
    },
  },
  components: {
    SellIn,
    SellOut,
    BuTable,
  },
  created() {
    this.getTime();
    this.getTypeData();
  },
};
</script>
<style  scoped>
.ellipsis {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.Pos_main {
  position: relative;
  left: 0;
  min-height: 740px;
  width: 100%;
  background: #f6f6ff;
  box-shadow: inset 0 2px 10px 0 rgba(0, 0, 0, 0.5);
  border-bottom-right-radius: 20px;
  border-bottom-left-radius: 20px;
  overflow: hidden;
}
.Pos_main .all_nav,
.Pos_main .Tmall_nav,
.Pos_main .stage_nav {
  background: #f6f6ff;
  box-shadow: 0 2px 10px 0 rgba(0, 0, 0, 0.5);
  border-radius: 20px;
  background: #01B198;
  border-radius: 22.5008px;
  height: 44px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.Pos_main .all_nav {
  margin: 20px 20px 0px 16px;
}
.Pos_main .Tmall_nav {
  margin: 0px 20px 10px 16px;
}
.Pos_main .stage_nav {
  margin: 0px 20px 10px 16px;
}

.Pos_main .all_nav p,
.Tmall_nav p,
.stage_nav p {
  margin-left: 15px;
  font-family: "微软雅黑" !important;
  font-size: 16px;
  color: #ffffff;
}

.Pos_main .all_nav span,
.Tmall_nav span,
.stage_nav span {
  opacity: 0.6;
  font-family: "微软雅黑" !important;
  font-size: 14px;
  color: #f3f3f3;
  text-align: center;
  margin-right: 15px;
}
.Pos_main .pos_all {
  position: relative;
  min-height: 200px;
  width: 100%;
  margin: 0 auto;
}

.pos_all {
  overflow: hidden;
}
.pos_Tmall {
  overflow: hidden;
}
.Full_stage {
  overflow: hidden;
}
</style>


// WEBPACK FOOTER //
// src/components/ButSecoend/Bu/Buindex.vue